/**
 * API route mappings
 *
 * This file centralizes all API endpoint paths used in the application.
 * If an endpoint changes, it only needs to be updated here.
 */

export const AUTENTICACAO_ROTAS = {
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  PERFIL: '/auth/perfil',
  PERMANECER_ATIVO: '/auth/permanecer-ativo',
}

export const USUARIO_ROTAS = {
  USUARIOS: '/usuarios',
  PAGINAS: (userId) => `/usuarios/${userId}/paginas`,
  ATUALIZA_ESTADO_PAGINA: (userId, pageId) => `/usuarios/${userId}/paginas/${pageId}/estado`,
  USUARIOS_LOGADOS: '/usuarios-logados',
}

export const NOTIFICACAO_ROTAS = {
  QUANTIDADE_MENSAGENS_AVALIACOES: '/notificacoes-usuario/count-mensagens-avaliacoes',
  QUANTIDADE_MARKETPRICE: '/notificacoes-usuario/count-marketprice',
  RANKING_USUARIOS: '/notificacoes-usuario/ranking-usuarios',
}

export const PERFIL_ROTAS = {
  PERFIS_USUARIO: '/perfis-usuario',
  PERMISSOES: '/permissoes-perfil',
  PAGINAS_PERFIL: (profileId) => `${profileId}/paginas`,
}

export const PEDIDO_ROTAS = {
  LISTAR_PEDIDOS: '/pedidos',
  PEDIDO: (id) => `/pedidos/${id}`,
  ACEITAR_PEDIDO: (id) => `/pedidos/${id}/aceitar-pedido`,
  REJEITAR_PEDIDO: (id) => `/pedidos/${id}/rejeitar-pedido`,
  REFAZER_PEDIDO: (id) => `/pedidos/${id}/refazer-pedido`,
  PEDIDO_ENTREGUE: (id) => `/pedidos/${id}/pedido-entregue`,
  OBSERVACAO_PEDIDO: (id) => `/pedidos/${id}/observacao`,
  OBSERVACAO_APLICATIVO: (id) => `/pedidos/${id}/observacao-aplicativo`,
  PEDIDO_PENDENTE: (id) => `/pedidos/${id}/pendente`,
  SOLUCOES: (id) => `/pedidos/${id}/solucoes`,
  AVISAR_PEDIDO: (id, revendedorId) => `/pedidos/${id}/avisar-pedido/${revendedorId}`,
  NOTIFICAR_ESTOU_NA_PORTA: (id) => `/pedidos/${id}/notificar-estou-na-porta`,
  SOLICITAR_ASSISTENCIA: (id) => `/pedidos/${id}/solicitar-assistencia`,
  REMOVER_SUSPEITO: (id) => `/pedidos/${id}/remover-suspeito`,
  REALIZAR_PEDIDO: '/pedidos/realizar-pedido',
  NOTIFICAR_ATRASO: (id) => `/pedidos/${id}/notificar-atraso`,
  NOTIFICAR_ATRASO_CLIENTE: (id) => `/pedidos/${id}/notificar-atraso-cliente`,
  PEDIDO_SAIU_PARA_ENTREGA: (id) => `/pedidos/${id}/sair-pedido`,
  LIGACAO_ATRASO: (id) => `/pedidos/${id}/ligacao-atraso`,
  PEDIDO_PENDENTE_HISTORICO: '/pedidos/pendente-historico',
}

// Novas rotas para assistência técnica
export const ASSISTENCIA_TECNICA_ROTAS = {
  LISTAR_ASSISTENCIAS: '/assistencias-tecnicas',
  ASSISTENCIA: (assistenciaId) => `/assistencias-tecnicas/${assistenciaId}`,
  NOTIFICAR_ESTOU_NA_PORTA: (assistenciaId) =>
    `/assistencias-tecnicas/${assistenciaId}/notificar-estou-na-porta`,
  OBSERVACAO_ASSISTENCIA: (assistenciaId) => `/assistencias-tecnicas/${assistenciaId}/observacao`,
  OBSERVACAO_ASSISTENCIA_REVENDA: (assistenciaId) =>
    `/assistencias-tecnicas/${assistenciaId}/observacao-revenda`,
  ACEITAR_ASSISTENCIA: (assistenciaId) => `/assistencias-tecnicas/${assistenciaId}/aceitar`,
  REJEITAR_ASSISTENCIA: (assistenciaId) => `/assistencias-tecnicas/${assistenciaId}/rejeitar`,
  SAIR_ASSISTENCIA: (assistenciaId) => `/assistencias-tecnicas/${assistenciaId}/sair-assistencia`,
  ASSISTENCIA_ENTREGUE: (assistenciaId) =>
    `/assistencias-tecnicas/${assistenciaId}/assistencia-entregue`,
  AVISAR_ASSISTENCIA: (assistenciaId, revendedorId) =>
    `/assistencias-tecnicas/${assistenciaId}/avisar-assistencia/${revendedorId}`,
  QUANTIDADE_ABERTAS: '/assistencias-tecnicas/count-abertas',
}

export const CLIENTE_ROTAS = {
  BLOQUEAR: (clientId) => `/clientes/${clientId}/bloquear`,
  DESBLOQUEAR: (clientId) => `/clientes/${clientId}/desbloquear`,
  BUSCAR_POR_TELEFONE: (telefone) => `/clientes/telefone/${telefone}`,
  REMOVER_MERECE_ATENCAO: (clienteId) => `clientes/${clienteId}/merece-atencao`,
}

export const REVENDEDOR_ROTAS = {
  LISTAR: '/revendedores',
  LISTAR_REVENDEDOR_GESTOR_CONTA: '/revendedor-gestor-conta',
  REVENDEDOR: (id) => `/revendedores/${id}`,
  ATIVAR_REVENDEDOR: (id) => `/revendedores/${id}/ativar`,
  DESATIVAR_REVENDEDOR: (id) => `/revendedores/${id}/desativar`,
  OBS_BOAS_VINDAS: (id) => `/revendedores/${id}/obs-boas-vindas`,
}

export const HORARIOS_FUNCIONAMENTO_ROTAS = {
  SET_HORARIOS: (revendaId) => `/horarios-funcionamento/${revendaId}`,
}

export const PAGAMENTO_ROTAS = {
  FORMAS_PAGAMENTO: '/formas-pagamento',
}

export const REVENDA_ROTAS = {
  BUSCAR_POR_REGIAO: '/revendas/por-regiao',
  BUSCAR_FABRICANTES: '/fabricantes',
  BUSCAR_TIPO_PRODUTOS: '/tipo-produtos',
  CADASTRAR_ENDERECO_SEM_REVENDEDOR: '/endereco-sem-revendedor',
  LISTAR: '/revendas',
  REVENDA: (id) => `/revendas/${id}`,
  ATIVAR_REVENDA: (id) => `/revendas/${id}/ativar`,
  DESATIVAR_REVENDA: (id) => `/revendas/${id}/desativar`,
  ATIVAR_LIGACAO_REVENDA: (id) => `/revendas/${id}/ligacao/ativar`,
  DESATIVAR_LIGACAO_REVENDA: (id) => `/revendas/${id}/ligacao/desativar`,

  TOGGLE_PRODUTO_STATUS: (revendaId, produtoId) =>
    `/revendas/${revendaId}/produtos/${produtoId}/toggle-status`,
  FORMAS_PAGAMENTO: (revendaId) => `/revendas/${revendaId}/formas-pagamento`,
  FORMA_PAGAMENTO: (revendaId, formaPgtoId) =>
    `/revendas/${revendaId}/formas-pagamento/${formaPgtoId}`,

  BUSCAR_POLIGONOS: (idrevenda) => `/revendas/${idrevenda}/poligonos`,
  SALVAR_POLIGONOS: (idrevenda) => `/revendas/${idrevenda}/poligonos`,
  HISTORICO_POLIGONOS: '/revendas/poligonos/historico',
}

export const PRODUTO_ROTAS = {
  PRODUTOS: `/produtos`,
  PRODUTO: (produtoId) => `/produtos/${produtoId}`,
}

export const MAPS_ROTAS = {
  AUTOCOMPLETE: '/maps/autocomplete',
  PLACE_DETAILS: '/maps/place-details',
  CHAVE_GOOGLE: '/chave-google/WEB',
}

export const ENDERECO_ROTAS = {
  BUSCAR_POR_CEP: (cep) => `/enderecos/cep/${cep}`,
}

// Novas rotas para boletos
export const BOLETO_ROTAS = {
  LISTAR_EM_ABERTO: '/cobrancas/revendedores/em-aberto',
  ENVIAR_WHATSAPP: '/cobrancas/revendedores/enviar-whatsapp',
}

// Rotas para campanhas marketing
export const CAMPANHAS_ROTAS = {
  PUSH: {
    CONTAR: '/clientes/campanhas/push/count',
    ENVIAR: '/campaigns/push',
  },
  WHATSAPP: {
    CONTAR: '/clientes/campanhas/whatsapp/count',
    ENVIAR: '/campaigns/whatsapp',
    TEMPLATES: '/whatsapp/templates',
  },
  SMS: {
    CONTAR: '/clientes/campanhas/sms/count',
    ENVIAR: '/campaigns/sms',
    LISTAR: '/campaigns/sms',
    OBTER: (id) => `/campaigns/sms/${id}`,
    CLICK_STATS: (id) => `/campaigns/sms/${id}/click-stats`,
    CANCELAR: (id) => `/campaigns/sms/${id}/cancelar`,
  },
}

// Rotas para templates WhatsApp
export const WHATSAPP_ROTAS = {
  TEMPLATES: '/whatsapp/templates',
  PARAMETROS: '/whatsapp/parametros',
}

// Rotas para mensagens do sistema
export const MENSAGEM_ROTAS = {
  LISTAR: '/mensagens',
  ENVIAR_WHATSAPP_COBRANCA: 'mensagens/enviar-whatsapp-cobranca-revendedor',
  ENVIAR_WHATSAPP_CREDITO_BAIXO: 'mensagens/enviar-whatsapp-credito-baixo',
}

// Routes for system configuration
export const CONFIGURACAO_ROTAS = {
  LISTAR_VARIAVEIS: '/configuracoes/variaveis',
  VARIAVEL: (id) => `/configuracoes/variaveis/${id}`,

  // New configuration routes
  LISTAR_CONFIGURACOES: '/configuracoes',
  CONFIGURACAO: (codigo) => `/configuracoes/${codigo}`,
  CRIAR_CONFIGURACAO: '/configuracoes',
  ATUALIZAR_CONFIGURACAO: (codigo) => `/configuracoes/${codigo}`,
}

// Routes for client messages
export const MENSAGENS_CLIENTE_ROTAS = {
  LISTAR: '/mensagens-cliente',
  ENVIAR_RESPOSTA: (id) => `/mensagens-cliente/${id}/observation`,
}

// Routes for 'avaliacao'
export const AVALIACAO_ROTAS = {
  LISTAR: '/avaliacao', // get
  CREATE_RESPONSE_AI: (id) => `/avaliacao/${id}/create-response-ia`, // post
  CHANGE_STATUS_AVALIACAO_OBS: (idAvaliacaoObs) =>
    `/avaliacao/${idAvaliacaoObs}/change-status-avaliacao-obs`, // put
  CHANGE_STATUS_ALL_AVALIACAO_OBS: '/avaliacao/resolve-all', // post
}

// Routes for 'revendas map' features
export const REVENDAS_MAP = {
  REVENDAS: '/revendas/map/area', // get
  PEDIDOS: '/revendas/map/pedidos', // get
  BUSCAR_ENDERECOS: '/revendas/map/address-searches', // get
  SAVE_COORDS: '/revendas/map/salvar-coords', // post
}

// Routes for financial features
export const FINANCEIRO_ROTAS = {
  ALICOTAS: '/tbconfig/alicotas', // get and put
  COMISSOES: '/tbconfig/comissoes', // get
  GERAR_BOLETO_PS: '/boleto-ps/gerar', // post
  GET_BOLETOS_PS: '/boleto-ps/gerenciar', // get
  STATUS_PROCESSO: (processId) => `/boleto-ps/status/${processId}`, // get
  ATUALIZAR_BOLETO_PS: (id) => `/boleto-ps/gerenciar/${id}/campos`, // put
  DETALHES_BOLETO_PS: (id) => `/boleto-ps/gerenciar/${id}/detalhes`, // get
  VALORES_BOLETO_PS: (id) => `/boleto-ps/gerenciar/${id}/valores`, // get
}

export const PRICE_ROTAS = {
  LIST_PRECOS_PRODUTOS: '/precos-produtos',
}

export const POS_VENDA_AVALIACAO_ROTAS = {
  LISTAR_POS_VENDA_AVALIACAO: '/pos-venda-avaliacao', // get
  CADASTRAR_POS_VENDA_AVALIACAO: '/pos-venda-avaliacao', // post
  EDITAR_POS_VENDA_AVALIACAO: (id) => `/pos-venda-avaliacao/${id}`, // put
  EXCLUIR_POS_VENDA_AVALIACAO: (id) => `/pos-venda-avaliacao/${id}`, // delete
}

export const REVENDA_METRICAS_ROTAS = {
  METRICAS: '/revendas/vitrine/metricas', // get
  REVENDAS: '/revendas/vitrine/revendas', // get
  REVENDEDORES: '/revendas/vitrine/revendedores', // get
  PEDIDOS_ENTREGUES: '/revendas/pedidos/entregues', // get
}

export const AVALIACAO_PLAY_STORE_ROTAS = {
  LISTAR: '/avaliacao-play-store', // get
  CADASTRAR: '/avaliacao-play-store', // post
  EDITAR: (id) => `/avaliacao-play-store/${id}`, // put
  DELETAR: (id) => `/avaliacao-play-store/${id}`, // delete
}
